/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Method_Bank_TransferInputs */

const en_my_payments_method_bank_transfer = /** @type {(inputs: My_Payments_Method_Bank_TransferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bank transfer`)
};

const pl_my_payments_method_bank_transfer = /** @type {(inputs: My_Payments_Method_Bank_TransferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`przelew`)
};

/**
* | output |
* | --- |
* | "bank transfer" |
*
* @param {My_Payments_Method_Bank_TransferInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_method_bank_transfer = /** @type {((inputs?: My_Payments_Method_Bank_TransferInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Method_Bank_TransferInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_method_bank_transfer(inputs)
	return en_my_payments_method_bank_transfer(inputs)
});